module.exports = __webpack_public_path__ + "content/649098ee1ea2f46630872b8022c2dfea.png";